import { ReaderList } from './ReaderList'
import { withReaderList } from './withReaderList'

const Connected = withReaderList(ReaderList)

export { Connected as ReaderList }
